import Link from 'next/link';
import { useRouter } from 'next/router';
import Avatar from './Avatar';
import DateComponent from './Date';
import PreviewImage from './PreviewImage';
import { analytics } from '../../lib/analytics';

export default function PostPreview({
  title,
  coverImage,
  date,
  excerpt,
  author,
  slug,
}) {
  const router = useRouter();
  const app = router.query.app;
  const link = `/blog/${slug}${app ? '?app=true' : ''}`;

  return (
    <div className="max-w-md p-2">
      <div className="w-full">
        <PreviewImage
          link={link}
          title={title}
          slug={slug}
          alt={title}
          src={coverImage.url}
          height={500}
          width={500}
          className="rounded-lg w-full h-56 mb-4"
        />
      </div>
      <div>
        <h3 className="text-2xl mb-3 leading-snug line-clamp-2">
          <Link
            href={link}
            className="hover:underline"
            onClick={() => {
              analytics.track('User Clicked Secondary Blog', {
                title,
                slug,
              });
            }}
          >
            {title}
          </Link>
        </h3>
      </div>
      <div className="text-md font-medium mb-4">
        <DateComponent dateString={date} />
      </div>
      <p className="text-lg leading-relaxed mb-4 line-clamp-4">{excerpt}</p>
      {author && <Avatar name={author.name} picture={author.picture} />}
    </div>
  );
}
